import { custom } from "zod";

/**
 * Centralized API endpoint mapping.
 *
 * Use these keys throughout services instead of hardcoding URL paths.
 * This makes it easy to adjust endpoints in one place.
 */
export const ENDPOINTS = {
  // Cart (new API)
  cartCreate: '/shop/cart',
  cartByCustomer: '/shop/cart/:customerId',
  cartUpdate: '/shop/cart/:customerId',
  cartReset: '/shop/cart/:customerId',

  // Legacy Cart (may still be used in some places)
  cartCurrent: '/orders/carts/current',
  cartById: '/orders/carts/:cartId',
  carts: '/orders/carts',
  checkoutCartByPayMethod: '/shop/payment/:paymethodId/checkout',
  checkoutCartByCartId: '/shop/cart/:cartId/checkout',

  // Products
  products: '/shop/products',
  productById: '/shop/products/:id',
  filterOptions: '/shop/filters',
  productLines: '/catalog/lines',
  productCategories: '/catalog/categories',
  productSizes: '/catalog/sizes',
  productColors: '/catalog/colors',
  in_sale_products: '/shop/in_sale',
  new_in_products: '/shop/new_in',

  // Shop
  shopSettings: '/shop/settings',
  shopAddresses: '/shop/shipping/addresses',
  settingsByKey: '/settings/key/:key',
  shopPayments: '/shop/payment',
  shopPaymentVerify: '/shop/payment/:paymentId/verify',
  shopCreateCustomer: '/shop/customer',
  shopCustomerProfile: '/shop/customer/:email',

  // Auth / user
  authMe: '/shop/auth/me',
  authLogin: '/shop/auth/login',
  authLogout: '/shop/auth/logout',
  customers: '/catalog/customers',
  customerById: '/catalog/customers/:id',
  customerForgotPassword: '/shop/auth/password-reset',
  customerResetPassword: '/shop/auth/password-recovery',

  // Catalog
  catalogCustomers: '/catalog/customers',
  catalogCustomersById: '/catalog/customers/:id',

  // Coupons
  coupons: '/orders/coupons',
  couponByCode: '/shop/coupons/:code',
  couponValidate: '/shop/coupons/:code/validate',

  // Shipping
  shippingProviders: '/shop/shipping/providers',
  shippingProviderById: '/shop/shipping/providers/:id',
  shippingProviderLocations: '/shop/shipping/:providerId/locations',
  shippingCalculate: '/shop/shipping-providers/:providerId/calculate',

  // Newsletter
  subscribeNewsletter: '/shop/newsletter/subscribe',
  unsubscribeNewsletter: '/shop/newsletter/unsubscribe',

  // FAQ/POST
  faqPosts: '/shop/faq',
  faqPostBySlug: '/shop/faq/:slug',
  posts: '/catalog/posts',
  postById: '/catalog/posts/:id',

  // Others (placeholder)
  // ... add new endpoints here
} as const;

export type EndpointKey = keyof typeof ENDPOINTS;
